import axiosInstance from "../config/Axios";
import axios from "axios";

// ── Legacy charge-based (kept for add-devices flow) ───────────────────────────

export const createStripeToken = async (cardData) => {
  const formData = new URLSearchParams();
  formData.append("card[number]", cardData.card_number.replace(/\s/g, ""));
  formData.append("card[exp_month]", cardData.expiry_date.slice(0, 2));
  formData.append("card[exp_year]", cardData.expiry_date.slice(3, 6));
  formData.append("card[cvc]", cardData.cvv);

  const response = await axios.post(
    `https://api.stripe.com/v1/tokens`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRIPE_PUBLISH_KEY}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
  return response.data.id;
};

export const processPayment = async ({ token, packageData }) => {
  const url =
    packageData.action === "addScreens"
      ? `/payment/add/devices`
      : `/payment/buy/package`;

  const response = await axiosInstance.post(url, {
    strip_token: token,
    package_id: packageData.selectedPackage?.id,
    period: packageData.selectedPricing?.period,
    number_of_devices: packageData.numberOfScreens,
    devices_list: packageData.ids,
  });

  return response.data;
};

// ── Stripe-native flows ───────────────────────────────────────────────────────

/**
 * Creates a Stripe Checkout session and returns { checkout_url }.
 * Frontend should redirect to checkout_url immediately after.
 */
export const createCheckoutSession = async ({
  packageId,
  period,
  numberOfDevices,
  devicesList,
}) => {
  const response = await axiosInstance.post("/payment/checkout-session", {
    package_id: packageId,
    period,
    number_of_devices: numberOfDevices,
    devices_list: devicesList || [],
  });
  return response.data;
};

/**
 * Creates a Stripe Customer Portal session and returns { portal_url }.
 * Frontend should redirect to portal_url to let the user manage billing.
 */
export const createPortalSession = async () => {
  const response = await axiosInstance.post("/payment/customer-portal");
  return response.data;
};

/**
 * Upgrades or downgrades an existing Stripe subscription.
 * Upgrade: takes effect immediately (Stripe charges the prorated difference).
 * Downgrade: scheduled to start after the current billing period.
 */
export const changePlan = async ({
  packageId,
  period,
  numberOfDevices,
  devicesList,
}) => {
  const response = await axiosInstance.post("/payment/change-plan", {
    package_id: packageId,
    period,
    number_of_devices: numberOfDevices,
    devices_list: devicesList || [],
  });
  return response.data;
};
